<template>

    <v-container fluid class="pa-0" ref="container">

        <v-row dense class="pt-0">

            <!-- PROJECT PROGRESS INDICATOR -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12">
                <stat-box
                    :value="completedPercent"
                    postfix="%"
                    hint="Percent completed"
                    :color="project.completed_count === 0 ? 'grey darken-1' : 'primary'"
                    :hintAtTop="true"
                    :mouseOverValue="project.completed_count"
                    mouseOverHint="# of completes"
                    :height="statusBoxHeight">
                </stat-box>
            </v-col>

            <!-- RESPONSE RATE -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="project.invited_count>0 && project.started_count>0">
                <response-rate-box
                    :project="project"
                    :height="statusBoxHeight"
                ></response-rate-box>
            </v-col>

            <!-- INCIDENCE RATE -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12">
                <incidence-rate-box :project="project"
                                    :height="statusBoxHeight"
                ></incidence-rate-box>
            </v-col>

            <!-- PROJECT START TIME -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="timeToLive!==false && project && project.status!=='closed'">
                <stat-box-text
                    :value="timeToLive"
                    :height="statusBoxHeight"
                    hint="Fielding starts"
                    :hint-at-top="true"
                ></stat-box-text>
            </v-col>

            <!-- PROJECT START TIME -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="timeToLive!==false && project && project.status==='closed'">
                <stat-box-text
                    :value="timeFromLive"
                    :height="statusBoxHeight"
                    hint="Deadline"
                    :hint-at-top="true"
                ></stat-box-text>
            </v-col>

            <!-- PROJECT DEADLINE -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="project && project.status!=='closed'">
                <stat-box-text
                    :value="timeToClose"
                    :height="statusBoxHeight"
                    :color="endDateInThePast ? 'red' : 'primary'"
                    hint="Project deadline"
                    :hint-at-top="true"
                    :mouseOverValue="endDateTime"
                    mouseOverHint="End time"
                ></stat-box-text>
            </v-col>

            <!-- TARGET COMPLETES -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12">
                <stat-box
                    :value="project.target_completes"
                    :height="statusBoxHeight"
                    hint="Target completes"
                    :hint-at-top="true"
                ></stat-box>
            </v-col>

            <!-- RATING -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-show="project.rating > 0">
                <stat-box
                    :color="calculateRatingColor(project.rating)"
                    :value="project.rating"
                    :height="statusBoxHeight"
                    hint="Rating"
                    :hint-at-top="true"
                ></stat-box>
            </v-col>

        </v-row>
    </v-container>

</template>

<script>

import {timeDisplay} from '../../../../components/mixins/timeDisplayMixin';
import {progress} from '../../../../components/mixins/progressMixin';
import {surveyRatingColor} from "../../../../components/mixins/surveyRatingColorMixin";
import {numberDisplay} from '../../../../components/mixins/numberDisplayMixin';

import ResponseRateBox from '../ResponseRateBox';
import StatBox from '../../../../components/UI/StatBoxNumerical';
import StatBoxText from "../../../../components/UI/StatBoxText";
import ProjectStatusBox from "../ProjectStatusBox";
import moment from 'moment';
import IncidenceRateBox from "../IncidenceRateBox";

export default {

    mixins: [timeDisplay, progress, surveyRatingColor, numberDisplay],

    components: {
        IncidenceRateBox,
        ResponseRateBox,
        StatBox,
        StatBoxText,
        ProjectStatusBox
    },

    props: {
        project: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            statusBoxHeight: 100,
            height: null,
        }
    },

    computed: {

        completedPercent() {
            const completedPercent = this.project.completed_count / this.project.target_completes * 100;

            if (completedPercent < 3) return this.roundValue(completedPercent, 1);

            return Math.round(completedPercent); // Zero decimals
        },

        timeToLive() {
            return this.toHumanTill(this.project.start_date, true);
        },

        timeFromLive() {
            return this.toHumanFrom(this.project.end_date, true);
        },

        endDateTime() {
            if (moment.utc(this.project.end_date).isAfter(moment().subtract(24, 'hours'))) {
                return this.toLocalTime(this.project.end_date);
            }
            return this.toLocalDate(this.project.end_date)
        },

        timeToClose() {

            // Don't display dead line box if start date hasn't happened yet
            if (this.endDateInThePast) {
                return this.toHumanFrom(this.project.end_date, true);
            }

            if (this.endDateInTheFuture) {
                return this.toHumanTill(this.project.end_date, false);
            }

            return this.toHumanTill(this.project.start_date, false);
        },

        endDateInTheFuture() {
            const endDate = moment.utc(this.project.end_date)
            return endDate.isAfter(moment.utc());
        },

        endDateInThePast() {
            const endDate = moment.utc(this.project.end_date)
            return endDate.isBefore(moment.utc());
        }
    },

    methods: {

        handleResize() {
            if (this.$refs.container) {
                this.height = this.$refs.container.innerHeight;
            }
        }
    },

    mounted() {
        window.addEventListener('resize', () => {
            this.handleResize();
        });

        this.handleResize();
    },

}
</script>
